import React, { useState, useEffect } from 'react'
import { Grid, Box } from "@material-ui/core"
import CustomTextField from '../../components/Common/CustomTextField'
import CustomButton from '../../components/Common/CustomButton'
import * as actions from "./actions"
import { useHistory, useLocation } from "react-router-dom"
import { toastError } from '../../utils'
const queryString = require('query-string');

const initialUser = {
    password: "",
    confirmPassword: "",
    passwordResetToken: ""
}

function ResetPassword() {
    const history = useHistory();
    const location = useLocation()

    const [user, setUser] = useState({ ...initialUser })
    const [loginLoader, setLoginLoader] = useState(false)
    // const [errors, setErrors] = useState({})
    const [showConfirm, setShowConfirm] = useState(false)

    useEffect(() => {
        const parsed = queryString.parse(location.search);
        if (parsed.token) {
            setUser({ ...user, passwordResetToken: parsed.token })
        } else {
            history.push('/login')
        }
    }, [])

    const onChangeHandler = (e) => {
        const { name = "", value = "" } = e.target
        setUser({ ...user, [name]: value })
        // setErrors({ ...errors, [name]: "" })
    }

    const keyPressed = e => {
        if (e.key === "Enter") {
            if (!loginLoader) {
                onConfirmEmail();
            }
        }
    }

    const onConfirmEmail = () => {
        if (!user.password || !user.confirmPassword) return
        if (user.password !== user.confirmPassword) return toastError('Password mismatch')
        setLoginLoader(true)
        actions.updatePassword({ password: user.password, passwordResetToken: user.passwordResetToken }).then(res => {
            setLoginLoader(false)
            setShowConfirm(true)
        }).catch(err => {
            setLoginLoader(false)
            setShowConfirm(true)
        })
    }

    const goToLoginPage = () => {
        history.push('')
    }

    return (
        <Grid container className="login-container">
            <Grid item xs={12} sm={7} md={4} lg={3} className="m-a">
                <Grid container >
                    <Grid item xs={12} className="p-10">
                        <Box className="welcome-login">
                            <h2>Welcome to Dry Bulk Matrix!</h2>
                        </Box>
                        {showConfirm ? <Box p={2} className="login-container-card">
                            <Grid item xs={12}>
                                <Box pt={2} pb={6}>
                                    <h2 className="login-heading" style={{ fontSize: '18px' }} >
                                        Password Changed Successfully
                                    </h2>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box pb={5}>
                                    <p className="forgot-password" style={{ fontSize: '16px' }} onClick={goToLoginPage}>Login</p>
                                </Box>
                            </Grid>
                        </Box> : <Box p={2} className="login-container-card">

                            <Grid item xs={12}>
                                <Box pt={2} pb={6}>
                                    <h2 className="login-heading">Reset Password</h2>
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box pt={2} pb={3}>
                                    <CustomTextField
                                        name="password"
                                        placeholder="New Password"
                                        value={user.password}
                                        onChange={onChangeHandler}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box pb={3}>
                                    <CustomTextField
                                        name="confirmPassword"
                                        placeholder="Confirm Password"
                                        value={user.confirmPassword}
                                        onChange={onChangeHandler}
                                        onKeyPress={keyPressed}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box pb={2}>
                                    <CustomButton
                                        onClick={onConfirmEmail}
                                        loader={loginLoader}
                                        disabled={loginLoader}
                                    >
                                        Reset Password
                                    </CustomButton>
                                </Box>
                            </Grid>

                        </Box>}
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    )
}

export default ResetPassword
